export const useUtil = () => {
  const isLangSelectActive = useState<boolean>('isLangSelectActive', () => false);

  return {
    isLangSelectActive,
  }
}
